import type { AxiosResponse } from 'axios';
import { httpWithAuth } from '~/clients';
import { DEALERSHIP_FACETS, FACETS } from '~/constants/endpoints';
import type {
  FacetData,
  InventoryRequest,
  Pagination
} from '~/contracts/common';

type FacetDataResponse = FacetData & { pagination: Pagination };

export default function fetchFacetData(
  request: InventoryRequest,
  controller: AbortController
): Promise<AxiosResponse<FacetDataResponse>> {
  const url = request.dealershipId ? DEALERSHIP_FACETS : FACETS;

  return httpWithAuth.post<FacetDataResponse>(url, request, {
    signal: controller.signal
  });
}
